import { HttpClient } from '@angular/common/http';
import { AppConfig } from './../config/app.config';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private clientID: string;
  private configDirPath = 'config/';
  private envFile = 'env.json';
  private config: Object = null;
  private env: Object = null;

  constructor(
    private http: HttpClient,
    public environment: AppConfig
  ) {}

  getConfig(key: any) {
    return this.config[key];
  }

  // Use native fetch() for init since HttpClient may not be ready during app initialization
  async init(): Promise<boolean> {
    try {
      const envResponse = await fetch(`${this.configDirPath}${this.envFile}`);
      if (!envResponse.ok) {
        console.log(`Configuration file '${this.configDirPath}${this.envFile}' could not be read`);
        return true;
      }

      this.env = await envResponse.json();
      const envName = (this.env as any).env;

      const validEnvs = ['prod', 'qa', 'tst', 'dev', 'local', 'sbx'];
      if (!validEnvs.includes(envName)) {
        console.error('Environment file is not set or invalid');
        return true;
      }

      const configResponse = await fetch(
        `${this.configDirPath}config.${envName}.json?${Math.random()}`
      );
      if (!configResponse.ok) {
        console.error(`Error reading '${envName}' configuration file.`);
        return true;
      }

      this.config = await configResponse.json();
      return true;
    } catch (error) {
      console.error('Error loading configuration:', error);
      return true;
    }
  }

  sendClientID() {
    return this.clientID;
  }
}
